import {sum, values} from 'lodash/fp'
import React, {Component} from 'react'

import {avgCo2} from '../../data/categories'

import Score from './Score'
import Progress from './Progress'

import './styles.css'


class Scores extends Component {
  render() {
    const {progress, questions, emissions} = this.props
    const co2 = sum(values(emissions))
    return (
      <div className="scores">
        <div className="scores-numbers">
          <Score title="Average American" score={avgCo2} />
          <div className="divider" />
          <Score title="Your Score" showTotal={true} score={co2 === undefined ? avgCo2 : co2}/>
        </div>
        <Progress
          percent={(progress + 1) / questions.length}
          label={`Question ${progress + 1} / ${questions.length}`}
        />
      </div>
    )
  }
}

export default Scores



// WEBPACK FOOTER //
// ./src/components/Scores/index.js